import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSignOutAlt } from '@fortawesome/free-solid-svg-icons';
import API_URL from '../config';

const Logout = () => {
  const navigate = useNavigate();
  const [isLoggingOut, setIsLoggingOut] = useState(false);

  const handleLogout = async () => {
    setIsLoggingOut(true);
    try {
      const response = await fetch(`${API_URL}/api/auth/logout/`, {
        method: 'POST',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        throw new Error('Logout failed');
      }

      // Clear any local storage or session data here if needed
      localStorage.clear();
      sessionStorage.clear();

      // Redirect to login page or home
      navigate('/', { replace: true });
    } catch (error) {
      console.error('Logout error:', error);
      setIsLoggingOut(false);
    }
  };

  const handleCancel = () => {
    navigate(-1); // Go back to previous page
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-gray-900">
      <div className="max-w-md w-full p-6 bg-white dark:bg-gray-800 rounded-lg shadow-md dark:shadow-gray-800">
        <div className="text-center mb-8">
          <div className="inline-block p-3 rounded-full bg-red-100 dark:bg-red-900/20 mb-4">
            <FontAwesomeIcon 
              icon={faSignOutAlt} 
              className="text-red-600 dark:text-red-500 text-3xl"
            />
          </div>
          <h2 className="text-2xl font-semibold text-gray-900 dark:text-gray-100 mb-2">
            Confirm Logout
          </h2>
          <p className="text-gray-600 dark:text-gray-400">
            Are you sure you want to log out?
          </p>
        </div>

        <div className="flex flex-col space-y-3">
          <button
            onClick={handleLogout}
            disabled={isLoggingOut}
            className={`w-full py-2 px-4 rounded-md text-white font-medium 
              ${isLoggingOut 
                ? 'bg-gray-400 dark:bg-gray-600 cursor-not-allowed' 
                : 'bg-red-600 hover:bg-red-700 dark:bg-red-600 dark:hover:bg-red-700 focus:ring-2 focus:ring-red-500 focus:ring-offset-2 dark:focus:ring-offset-gray-800'
              } transition-colors duration-200`}
          >
            {isLoggingOut ? 'Logging out...' : 'Yes, log me out'}
          </button>
          <button
            onClick={handleCancel}
            disabled={isLoggingOut}
            className="w-full py-2 px-4 rounded-md border border-gray-300 dark:border-gray-600 
              text-gray-700 dark:text-gray-300 font-medium bg-white dark:bg-gray-700 hover:bg-gray-50 
              dark:hover:bg-gray-600 focus:ring-2 focus:ring-gray-500 focus:ring-offset-2 dark:focus:ring-offset-gray-800 
              transition-colors duration-200"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default Logout; 